function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export class Tooltip {

    constructor(element, options) {
        this.element = element;
        this.init();
        this.conf = options;
    }

    // Mouse entern
    onMouseEnter() {
        let _this = this;
        this.element.classList.add('tooltip');
        let content = document.createElement('div'); // is a node
        content.classList.add('tooltip-item');
        content.innerHTML = this.conf.content;

        this.element.appendChild(content);

        // setTimeout(function () {

        // });
        let element = _this.element.querySelector('.tooltip-item');
        setTimeout(function () {
            let top = (element.getBoundingClientRect().height + 5);
            element.style.top = ('-' + top + 'px');
            const tooltipItem = _this.element.querySelector('.tooltip-item');
            if (tooltipItem) {
                tooltipItem.classList.add('is-open');
            }
        }, 1);
    }

    onMouseLeave() {
        this.element.classList.remove('tooltip');

        let node = this.element.querySelector('.tooltip-item');
        node.parentNode.removeChild(node);
    }

    init() {
        let _this = this;
        this.element.addEventListener('mouseenter', function () {
            _this.onMouseEnter();
        });

        this.element.addEventListener('mouseleave', function () {
            _this.onMouseLeave();
        });
    }
}
